import React from 'react';

type PeriodActivity = { total: number; passes: number; shots: number; duels: number };

const ActivityByPeriodSection: React.FC<{
  periods: Array<[string, PeriodActivity]>;
  maxPeriodTotal: number;
}> = ({ periods, maxPeriodTotal }) => (
  <div>
    <h5 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3">Activity by Period</h5>
    <div className="space-y-2">
      {periods.map(([period, activity]) => {
        const barWidth = (activity.total / maxPeriodTotal) * 100;
        return (
          <div key={period}>
            <div className="flex justify-between text-xs text-gray-700 dark:text-gray-300 mb-0.5">
              <span className="font-medium">{period}</span>
              <span>{activity.total} events ({activity.passes}P / {activity.shots}S / {activity.duels}D)</span>
            </div>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
              <div
                className="bg-indigo-500 dark:bg-indigo-400 rounded-full h-2.5 transition-all"
                style={{ width: `${barWidth}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default ActivityByPeriodSection;
